import ClickTracking from '@/share/campaign/click-tracking-mixin'

export default {
  mixins: [ClickTracking],

  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelNameForAnalytics() {
      return 'X (Twitter)'
    }
  },

  methods: {
    handleClick() {
      const shareClickToken = this.trackEvent()
      const url = this.urlWithShareClickTokenInInnerUrl(this.sharingOptions.href, shareClickToken, 'url')
      const popup = window.open('about:blank', 'sharer', 'toolbar=0,status=0,width=626,height=436')
      popup.location.href = url
    }
  }
}
